export const CARD_MESSAGES = {
  MODAL: {
    DISASSOCIATE_WITH_BALANCE: (cardNumber: string) =>
      `La tarjeta ${cardNumber} no se puede desasociar del centro de costo porque tiene saldo disponible. Transfiera el saldo a otra cuenta antes de continuar.`,
    CHANGE_CC_WITH_BALANCE: (cardNumber: string) =>
      `La tarjeta ${cardNumber} no se puede cambiar de centro de costos porque tiene saldo disponible. Transfiera el saldo a otra cuenta antes de continuar.`,
    ASSOCIATE_WITH_BALANCE: (cardNumber: string) =>
      `La tarjeta ${cardNumber} no se puede asociar a un centro de costos porque tiene saldo disponible. Transfiera el saldo antes de continuar.`,
    DISASSOCIATE_CONFIRMATION: {
      TITLE: 'Desasociar Tarjeta',
      BODY: (cardNumber: string, costCenterName: string) =>
        `¿Desea desasociar la tarjeta ${cardNumber} del centro de costos ${costCenterName}?`,
    },
  },
  NOTIFICATIONS: {
    DISASSOCIATE_SUCCESS: (cardNumber: string) =>
      `La tarjeta ${cardNumber} ha sido desasociada correctamente.`,
    DISASSOCIATE_ERROR: 'Error al desasociar la tarjeta. Por favor, intente nuevamente.',
  },
  // agregar más mensajes
};